// extracted by mini-css-extract-plugin
export default {"container":"u1-z","heading":"v1-z","links":"w1-z","copy":"x1-z","subCopy":"y1-z","linksLeft":"z1-z","linksCenter":"A1-z","linksRight":"B1-z","link":"C1-z","onlyLink":"D1-z"};